import { defineStore } from 'pinia';

import * as state from './export.state';
import * as getters from './export.getters';
import * as actions from './export.actions';

export const useExportStore = defineStore('export', () => ({
  ...state,
  ...getters,
  ...actions
}));
